import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/ProfilePage";
import Skills from "./pages/Skills";
import AvatarCustomization from "./pages/AvatarCustomization";
import Redeem from "./pages/Redeem";
import Admin from "./pages/Admin";
import theme from "./theme";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Box
          sx={{ minHeight: "100vh", background: "var(--dashboard-page-bg)" }}
        >
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/skills"
                element={
                  <PrivateRoute>
                    <Skills />
                  </PrivateRoute>
                }
              />
              <Route
                path="/avatar"
                element={
                  <PrivateRoute>
                    <AvatarCustomization />
                  </PrivateRoute>
                }
              />
              <Route
                path="/redeem"
                element={
                  <PrivateRoute>
                    <Redeem />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <Admin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/main"
                element={<Navigate to="/dashboard" replace />}
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </Box>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
